// Mirrors DeviceAppType on the backend. SelfServe tablets are locked to a
// Self Serve Location; all other app types use an AEV Location.
// NOTE: "Arrivals" was removed from the options (unified kiosk plan, U2) —
// a T2 Arrivals kiosk is app type PreCheck + location "T2 Arrivals"; the
// arrivals behaviour comes from the location's access-level config. The
// backend enum still accepts the value for any legacy devices.
export const APP_TYPES = [
  { name: "Self Serve", value: "SelfServe" },
  { name: "PreCheck", value: "PreCheck" },
  { name: "Person Audit", value: "Audit" },
  { name: "Officer Dashboard", value: "Dashboard" },
];

// Display name for a stored appType, falling back to the raw value for
// legacy devices (e.g. "Arrivals", no longer offered as an option).
export const appTypeName = (appType: string) =>
  APP_TYPES.find((type) => type.value === appType)?.name ?? appType;

export const usesSelfServeLocation = (appType: string) => appType === "SelfServe";

// Per-app-type hint under the Location field. The Officer Dashboard is locked
// to the location whose check-in queue it displays.
export const locationHint = (appType: string) => {
  switch (appType) {
    case "SelfServe":
      return "The Self Serve location this kiosk checks people in to.";
    case "Dashboard":
      return "The location whose check-in queue this dashboard displays. Officers cannot change it on the tablet.";
    default:
      return "The location this tablet is locked to.";
  }
};
